import { IfPartnerUser } from 'models/partner/IfPartnerUser';
import { create } from 'zustand';

type ZstdPartner = {
  partnerUserList: IfPartnerUser[];
  setPartnerUserList: (partnerUserList: IfPartnerUser[]) => void;
};

export const useZstdPartner = create<ZstdPartner>((set) => ({
  partnerUserList: [],
  setPartnerUserList: (partnerUserList: IfPartnerUser[]) => set({ partnerUserList }),
}));
